export default __webpack_public_path__ + "static/media/app-home.0469354b.png";